/**
 * EventManager - Simple pub/sub event bus for widget communication
 */
export default class EventManager {
    constructor() {
        this._listeners = {};
    }

    /**
     * Subscribe to an event
     */
    on(event, callback) {
        if (!this._listeners[event]) {
            this._listeners[event] = [];
        }
        this._listeners[event].push(callback);
        return this;
    }

    /**
     * Unsubscribe from an event
     */
    off(event, callback) {
        if (!this._listeners[event]) return this;
        if (callback) {
            this._listeners[event] = this._listeners[event].filter(cb => cb !== callback);
        } else {
            delete this._listeners[event];
        }
        return this;
    }

    /**
     * Emit an event with data
     */
    emit(event, data = {}) {
        if (!this._listeners[event]) return this;
        this._listeners[event].forEach(callback => {
            try {
                callback(data);
            } catch (e) {
                console.error(`[A11Y] Event handler error (${event}):`, e);
            }
        });
        return this;
    }

    /**
     * Subscribe to an event once
     */
    once(event, callback) {
        const wrapper = (data) => {
            callback(data);
            this.off(event, wrapper);
        };
        return this.on(event, wrapper);
    }

    /**
     * Remove all listeners
     */
    removeAll() {
        this._listeners = {};
        return this;
    }
}
